import React, {useState, useContext, useRef, useEffect} from "react";

import {StyleSheet, Text, View, TextInput, BackHandler}  from 'react-native'

import contexto from '../util/contexto'

import {estilos} from '../util/estilos'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import * as data from '../util/data'

import cores from '../util/cores'

import * as texto from '../util/texto'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {buscarMensagensPorChat, enviarMensagem as wsEnviarMensagem} from '../ws/ws_chat'

import {semDados} from '../componentes/SemDados'

import {carregamento} from '../componentes/Carregamento'

import {height, TELA_PRINCIPAL, DNC_TIPO_SERVICO_MENSAGEM, TELA_NOVA_DENUNCIA} from '../util/constantes'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import InfosLoja from '../componentes/InfosLoja'

import {buscar_loja} from '../ws/ws_usuarios'





export default function TelaChat(){

	const {valorContexto, setValorContexto} = useContext(contexto);

	const [sincronizando, setSincronizando] = useState(true)  
   
	const [mensagem, setMensagem] = useState(null)
	
	const [temMensagemDigitada, setTemMensagemDigitada] = useState(false)  
	
	const navegacao = new useNavigation();
	
	const flatListRef = useRef(null);

	const [enviandoMensagem, setEnviandoMensagem] = useState(false) 
	
	const [loja, setLoja] = useState(null) 

	const [chat, setChat] = useState(null)
	
	const [podeBuscarMensagens, setPodeBuscarMensagens] = useState(false);

	

	const voltar = () => {
		
		setPodeBuscarMensagens(false);

		navegacao.replace(util.processaVoltar())
		
		return true;
	};

	
	useFocusEffect(React.useCallback(() => {

		util.print("TelaChat");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarDados();
	
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};

	}, []));
	
	
	const buscarDados= async ()=>{

		util.print('TelaChat - buscando mensagens');

		setSincronizando(true)

		setPodeBuscarMensagens(false);

		const id_usuario_destino = await buscarMensagens();

		if(id_usuario_destino!=null)
			setLoja(await buscar_loja(id_usuario_destino))
			
		setSincronizando(false);

		setPodeBuscarMensagens(true);
	}


	const buscarMensagens= async ()=>{

		util.print('TelaChat - buscarMensagens');

		let dados  = await buscarMensagensPorChat(valorContexto.idChat!=null?parseInt(valorContexto.idChat):null, 
										valorContexto.idProposta!=null?parseInt(valorContexto.idProposta):null);

		if(dados!=null){
			
			if(chat ==null)
				setChat(dados);
			else{
				
				util.print(chat.mensagens.length+" "+dados.mensagens.length);

				if(chat.mensagens.length< dados.mensagens.length)
					setChat(dados);
			}
			
			return dados.id_usuario_proposta == valorContexto.idUsuarioAtual?dados.id_usuario_pedido:dados.id_usuario_proposta;
		}
		
		return null;
	}

	
	const enviarMensagen= async ()=>{

		util.print("enviarMensagen");
		
		if(texto.isBlanck(mensagem))	
			return;
	
		setEnviandoMensagem(true)
	
		setMensagem(null);
	
		let id_retorno = await wsEnviarMensagem(valorContexto.idUsuarioAtual, mensagem, chat.id);
		
		if(id_retorno!=null){
			
			//let mensagens = chat;

			if(chat.mensagens==null)
				chat.mensagens = []

			chat.mensagens.push({
                "id": id_retorno,
                "fk_chat": chat.id,
                "fk_remetente": valorContexto.idUsuarioAtual,
                "mensagem": mensagem,
                "data_envio": data.getDataAtual(false, true)
            });	

			setChat(chat);
			
			handleLayout();
		}
		
		setEnviandoMensagem(false)
	}


	const digitando=(msg)=>{

		setMensagem(msg);
		
		setTemMensagemDigitada(texto.isNotBlanck(msg));	
	}
	
	
	const handleLayout = () => {
		
		util.print("handleLayout")

		if(flatListRef.current!=null && chat!=null && util.temConteudo(chat.mensagens)){
			util.print("handleLayout ok")
			flatListRef.current.scrollToEnd({ animated: true });
		}
	};
	
	useEffect(() => {handleLayout()}, [chat, sincronizando]);
	

	useEffect(() => {
		
		let intervalId;

		if (podeBuscarMensagens)
			intervalId = setInterval(() => {buscarMensagens()}, 15000);
		else
			clearInterval(intervalId);


		return () => {clearInterval(intervalId);};

	  }, [podeBuscarMensagens]);


	return (
		<ViewDegradeVertical titulo="Mensagens" voltar={()=>voltar()}>  
			{(sincronizando) ?
				(carregamento(sincronizando)):
				(
				<View style={{flex: 1}}>
					<InfosLoja loja={loja} titulo="Solicitante">
					{valorContexto.idChat!=null && 
							<View>	
								<View style={{marginTop:10}}/> 
								<View style={{alignItems:'center'}}>	
									<Botao 
										acao={()=>{
											
											setValorContexto(prevState =>({...prevState, tipoDenuncia: DNC_TIPO_SERVICO_MENSAGEM}));

											setValorContexto(prevState =>({...prevState, idRelacaoDenuncia: valorContexto.idChat}));

											navegacao.replace(TELA_NOVA_DENUNCIA)
										}}
										somente_texto={true}
										texto="Denunciar Mensagem"/>   
								</View>
								<View style={{marginTop:10}}/> 
							</View>	
						}	
					</InfosLoja>

						{(enviandoMensagem) ?
							(<View>
								<View style={{marginTop:25}}/>
									{carregamento(enviandoMensagem)}
								<View style={{marginTop:25}}/>
							</View>):
							(<View style={estilos.grade}>
								<View style={[estilos.coluna, {marginTop:10, marginRight:5}]}> 
									<TextInput
										placeholder="Nova mensagem..."
										style={estilos.campo_padrao} 
										multiline={false}
										onChangeText={(text)=>digitando(text)}
										maxLength={250}
										value={mensagem}/>
								</View>
								<View>
									{temMensagemDigitada && 
										<Botao
											acao={()=>enviarMensagen()}
											texto="Enviar"
											cor={cores.azul}/>  
									} 
								</View>
								<View style={{marginTop:10}}/>
							</View>)
						}
					
					
						<View style={{height:(height-250), marginTop:10}}>
							{chat!=null && util.temConteudo(chat.mensagens)?
								(<Scroll ref={flatListRef}> 
									<Bloco todaArea={true}> 
										{chat.mensagens.map((item, index) =>itemLista(item, index))}
									</Bloco>
								</Scroll>):
								(<Bloco todaArea={true}> 
									{semDados("info", "Ainda não há mensagens.", 60)}
									
								</Bloco>)
							}
						</View>
				</View>) 


			}



		</ViewDegradeVertical>
	); 
	
	
	function itemLista(item, index){

		return (
			<View key={index}>
				{item.fk_remetente == valorContexto.idUsuarioAtual?
					(<View style={styles.area_geral_minha_msg}>
						<View style={{alignItems:'flex-end'}}> 
							<Text style={[estilos.rotulo_menor, {color:cores.fonte_clara}]}>{data.converteDataEuaParaBr(item.data_envio, false)}</Text>
						</View>
						<View style={{marginTop:5}}/>	
						<View style={estilos.separador_claro}/> 
						<View style={{marginTop:5}}/>	
						<View>
							<Text style={[estilos.rotulo_padrao, {color:cores.fonte_clara}]}>{item.mensagem}</Text>	    
						</View>
						<View style={{marginTop:5}}/>	
					</View>):
					(<View style={styles.area_geral_msg_recebida}>
						<View style={{alignItems:'flex-start'}}> 
							<Text style={[estilos.rotulo_menor, {color:cores.fonte_clara}]}>{data.converteDataEuaParaBr(item.data_envio, false)}</Text>   
						</View>
						<View style={{marginTop:5}}/>	
						<View style={estilos.separador_claro}/> 
						<View style={{marginTop:5}}/>
						<View>
							<Text style={[estilos.rotulo_padrao, {color:cores.fonte_clara}]}>{item.mensagem}</Text>	 
						</View>
						<View style={{marginTop:5}}/>	
					</View>)
				}
			</View>
		)
	}
}


const styles = StyleSheet.create({

	area_geral_minha_msg:{
		borderRadius:10,
		marginLeft:60,
		marginRight:2,
		marginBottom:10,
		marginTop:10,
		backgroundColor: cores.azul,
		padding: 10
    },
	
	area_geral_msg_recebida:{
		borderRadius:10,
		marginLeft:2,
		marginRight:60,
		marginBottom:10,
		marginTop:10,
		backgroundColor: cores.roxo,
		padding: 10
    }
})